import { query } from '@confluence/query-preloader-tools/entry-points/graphql';
import {
	superbatchCSSRecorder,
	superbatchJSRecorder,
} from '@confluence/ssr-utilities/entry-points/SuperbatchResourceRecorder';
import { removeJquery, convertSuperBatchResourceToScriptTags } from '@confluence/dom-helpers';

import { FrontendResourceRenderQuery } from '../src/helpers/FrontendResourceRenderQuery.graphql';

export async function preloadSuperBatchData({
	preloadSuperBatchForSSR = false,
}: {
	preloadSuperBatchForSSR?: boolean;
} = {}) {
	if (preloadSuperBatchForSSR) {
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		const superbatchData = await query({ query: FrontendResourceRenderQuery });
		const resourceList =
			(superbatchData?.data as any)?.internalFrontendResource?.resourceList || [];
		const { js, css } = resourceList.reduce(
			(
				acc: { js: string[]; css: string[] },
				resource: {
					url: string;
					type: 'css' | 'js';
					attributes: Array<{ key: string; value: string }>;
					__typename: string;
				},
			) => {
				const html = convertSuperBatchResourceToScriptTags(resource);
				acc[resource.type].push(html);
				return acc;
			},
			{ js: [], css: [] },
		);

		superbatchJSRecorder.add(removeJquery(js.join('\n')));
		superbatchCSSRecorder.add(css.join('\n'));
	} else if (
		// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
		!process.env.REACT_SSR &&
		!window.__SUPERBATCH_REQUESTED__
	) {
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		return query({ query: FrontendResourceRenderQuery });
	}
	return Promise.resolve();
}
